module.exports = __webpack_public_path__ + "6f3b1b9634247546e94e6de707056a99.svg";